import React from 'react';
import './Loading.scss';
import { getDeviceInfo, teslaCacheX } from '../../Upshow';
import ReactPlayer from 'react-player';
import Logger from '../../Logger';
import { isXumoDevice } from '../../utils/isXumoDevice';

const LoadingScreen = ({url})=> {

    return (isXumoDevice()?
                <img src='https://cdn.upshow.tv/ui-assets/Xumo_Loading_Screen.jpg'  alt="Loading" style={{width:' 100%', height: 'auto'}}/>
                :<ReactPlayer
                    width="100%" height="100%" volume={0} playing
                    url={url}
                    onError={(error) => Logger.warn('Loading state could not play loading media', error)}
                    config={{
                        file: {
                            attributes: {
                                crossOrigin: 'anonymous',
                                poster: 'https://cdn.upshow.tv/1x1.png'
                            }
                        }
                    }}/>)

}

class Loading extends React.Component {
    constructor (props) {
        super(props);
        this.url = teslaCacheX('https://cdn.upshow.tv/ui-assets/Everpass_Logo_Animation.mp4');
    }

    render () {
        return <div className="Loading">
            {['AndroidSkykit','Skykit'].includes(getDeviceInfo().model)
                ? <></>
                :  <LoadingScreen url={this.url}/>
            }
        </div>;
    }
}

export default Loading;